import { CheckClientDocument } from '@/model/CheckClientDocument';

export const isPendingFixes = (data?: CheckClientDocument): boolean => {
  if (!data) return false;
  if (!data.validation) return false;
  if (!data.validation.requiredActions) return false;
  return data.validation.requiredActions.length > 0;
};
